import { z } from 'zod';
/** Contract for `GET /api/health`. Shared so the client can validate the boundary. */
export const healthResponseSchema = z.object({
    status: z.literal('ok'),
    service: z.literal('awwyeah-server'),
    version: z.string(),
    time: z.string(),
    uptimeSeconds: z.number().nonnegative(),
});
/** WebSocket path the Yjs sync hub will be mounted on (WS-1). */
export const SYNC_WS_PATH = '/sync';
//# sourceMappingURL=api.js.map